import type { FieldErrors } from "react-hook-form";

/** The refused field can be anywhere in a sheet that scrolls, so the reason the
 *  save did not happen is repeated next to the button that was pressed. When
 *  the caller can say which fields the partner sees first, the sentence names
 *  the same field the sheet scrolls to — naming one and scrolling to another is
 *  what the silent refusal felt like in the first place. */
export function refusedFieldMessage(
  errors: FieldErrors,
  fieldNamesInReadingOrder?: readonly string[],
): string | null {
  const refusedNames = Object.keys(errors);
  if (refusedNames.length === 0) return null;

  const ordered = fieldNamesInReadingOrder
    ? fieldNamesInReadingOrder.filter((name) => refusedNames.includes(name))
    : refusedNames;

  for (const name of ordered.length > 0 ? ordered : refusedNames) {
    const message = errors[name]?.message;
    if (typeof message === "string") return message;
  }
  return "Opravte označená pole.";
}
